import axios from 'axios';

import { returnBaseUrlBackend } from '../helpers/Utils';

const api = axios.create({
  baseURL: returnBaseUrlBackend(),
});

api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
